import React from "react";

const Li = ({ children }) => {
  return (
    <>
      <li>{children}</li>
    </>
  );
};

export default Li;
